export default __webpack_public_path__ + "static/media/attach-sketch.0eec9a89.gif";